import React from 'react';

import { 
  Paper,
  ButtonGroup,
  Button,
  Divider
} from 'e100-react-components';

import googleMapIcon from './GoogleMap.svg';
import hereMapIcon from './HereMap.svg';

import { MAP_NAMES } from 'entities/map';

import {
  useIsActiveGoogleMap,
  useIsActiveHereMap
} from 'entities/map';
import { useHandleClickMapType } from '../../hooks';
import { useStyles } from './styles';

export const DesktopMapTypeSwitcher = () => {
  const classes = useStyles();
  const isActiveGoogleMap = useIsActiveGoogleMap();
  const isActiveHereMap = useIsActiveHereMap();
  const handleClickMapType = useHandleClickMapType();

  return (
    <div className={classes.container}>
      <Paper>
        <ButtonGroup variant="contained" disableElevation>
          <Button
            classes={{
              root: `${classes.firstButton} ${isActiveGoogleMap ? classes.activeButton : ''}`,
              label: classes.buttonLabel,
            }}
            startIcon={<img src={googleMapIcon} alt="Google map icon" />}
            onClick={() => {
              handleClickMapType(MAP_NAMES.google);
            }}
          >
            {'Google'}
          </Button>
          <Divider
            orientation="vertical"
            classes={{
              root: classes.divider
            }}
          />
          <Button
            classes={{
              root: `${classes.secondButton} ${isActiveHereMap ? classes.activeButton : ''}`,
              label: classes.buttonLabel
            }}
            startIcon={<img src={hereMapIcon} alt="Here map icon" />}
            onClick={() => {
              handleClickMapType(MAP_NAMES.here);
            }}
          >
            {'Here'}
          </Button>
        </ButtonGroup>
      </Paper>
    </div>
  );
};
